import { useQuota } from './api';

/** Фолбэк совпадает с дефолтом секции Forwarding в appsettings.json. */
const FALLBACK = true;

/**
 * Скрывает ли бэкенд входящие письма ящиков с включённой переадресацией
 * (настройка `Forwarding:HideIncomingMessages`, promt-81 §Q5). Списки писем таких ящиков
 * приходят пустыми, поэтому UI не показывает и счётчик непрочитанных.
 */
export function useForwardingHidden() {
  const quota = useQuota();
  return quota.data?.forwarding?.hideIncomingMessages ?? FALLBACK;
}
